module.exports = __webpack_public_path__ + "media/images/npcc_logo_dark-803e67ef75dbdc9ac23ff23428cdbb6b.svg";